<template>
  <graphql-requester
    :gql="$options.GET_INSURANCE_CARD_SCAN_INFO"
    v-slot="{ gqlRequest, loading, error }"
    @on:result="onResult"
  >
    <validation-provider
      tag="div"
      name="upload_image_insurance"
      :rules="rules"
      mode="passive"
      v-slot="{ errors }"
      role="form"
      aria-label="Insurance card upload form"
    >
      <form-upload-image
        id="upload_image_insurance"
        v-model="internalValue"
        :disabled="loading"
        @input="onInput"
        @change="onChange($event, gqlRequest)"
        aria-label="Upload insurance card image"
        aria-required="true"
        :aria-invalid="!!errors[0]"
        :aria-describedby="errors[0] ? 'error-message' : 'helper-text'"
      ></form-upload-image>
      <form-alert-msg
        v-if="errors[0]"
        id="error-message"
        role="alert"
        aria-live="assertive"
      >
        {{ errors[0] }}
      </form-alert-msg>
      <p
        v-if="loading"
        class="text-sm text-center mt-4"
        role="status"
        aria-live="polite"
      >
        Processing your Insurance photo...
      </p>
      <p
        v-if="error"
        class="text-sm text-center mt-4 text-red-400"
        role="alert"
        aria-live="assertive"
      >
        Something went wrong. Please try again.
      </p>
      <div id="helper-text">
        <p
          class="text-sm text-center mt-4 text-#7D7D7D"
          role="note"
        >
          Your Insurance Card photo will be used to automatically fill in your
          insurance information.
        </p>
        <p
          class="text-sm text-center text-#7D7D7D"
          role="note"
        >
          The image or information will not be shared without your consent.
        </p>
      </div>
      <div
        class="flex space-x-4 mt-8"
        role="group"
        aria-label="Form actions"
      >
        <button-secondary
          type="button"
          class="w-full px-10 py-3"
          :colors="{
            backgroundColor: '#BCBCBC',
            borderColor: '#BCBCBC',
            color: '#FFFFFF',
          }"
          :disabled="loading"
          :aria-disabled="loading"
          @click="$emit('on:cancel')"
          aria-label="Cancel insurance card upload"
        >
          Cancel
        </button-secondary>
        <button-primary
          :disabled="!hasValue || loading || error"
          :aria-disabled="!hasValue || loading || error"
          type="button"
          class="w-full px-10 py-3"
          @click="onContinue"
          aria-label="Continue with insurance card upload"
        >
          Continue
        </button-primary>
      </div>
    </validation-provider>
  </graphql-requester>
</template>

<script>
import { GET_INSURANCE_CARD_SCAN_INFO } from "@/graphql";
import GraphqlRequester from "@/components/GraphqlRequesterLite.vue";
import { FormUploadImage, FormAlertMsg } from "@/components/Form/";
import ButtonSecondary from "@/components/Button/ButtonSecondary.vue";
import ButtonPrimary from "@/components/Button/ButtonPrimary.vue";
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", { ...required, message: "This field is required." });

export default {
  GET_INSURANCE_CARD_SCAN_INFO,
  components: {
    ValidationProvider,
    FormUploadImage,
    FormAlertMsg,
    ButtonPrimary,
    ButtonSecondary,
    GraphqlRequester,
  },
  props: ["value", "controls"],
  data() {
    return {
      internalValue: "",
      data: null,
    };
  },
  computed: {
    rules() {
      return "required";
    },
    hasValue() {
      return this.internalValue;
    },
  },
  watch: {
    value: {
      handler(value) {
        if (!value) return;
        this.internalValue = value?.file;
        this.data = value?.data;
      },
      immediate: true,
    },
  },
  methods: {
    onInput(file) {
      this.$emit("input:field", { file });
    },
    onChange(value, gqlRequest) {
      if (!value) return;
      const file_base_64 = value;
      const company_id = this.$store.state?.config?.companyId;
      const location_id = this?.controls?.locations?.location_id;

      gqlRequest({
        input: {
          file_base_64,
          company_id,
          location_id,
        },
      });
    },
    onResult(data) {
      // console.log("data", data);
      if (!data) return;
      this.data = data?.scanInsuranceCardQuery || {};

      this.$emit("input:field", {
        ...this.value,
        data: this.data,
      });
    },
    onContinue() {
      this.$emit("on:continue", this.data);
    },
  },
};
</script>

<style scoped>
.text-\#7D7D7D {
  color: #7d7d7d;
}
</style>
